<template>
  <div class="crm-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="关键字">
          <el-input v-model="filterForm.keyword" placeholder="手机号/姓名/昵称/推广码" clearable style="width: 200px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="代理身份">
          <el-select v-model="filterForm.is_agent" placeholder="全部" clearable style="width: 140px;">
            <el-option label="普通会员" :value="0" />
            <el-option label="代理" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">添加会员</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="memberList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column label="头像" width="70" align="center">
          <template slot-scope="scope">
            <el-avatar :size="36" :src="scope.row.mem_img || defaultAvatar" />
          </template>
        </el-table-column>
        <el-table-column label="会员" min-width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.mem_user || '-' }}</div>
            <div class="sub-text">
              {{ scope.row.mem_name || scope.row.mem_nick || ('ID:' + scope.row.id) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="等级" width="70" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="info">Lv.{{ scope.row.mem_rank || 1 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="invite_code" label="邀请码" width="100" align="center" />
        <el-table-column prop="mem_code" label="推广码" width="300" align="center" show-overflow-tooltip />
        <el-table-column label="代理身份" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="Number(scope.row.is_agent) === 1 ? 'warning' : 'success'">
              {{ Number(scope.row.is_agent) === 1 ? '代理' : '普通' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mem_num" label="会员数" width="80" align="center" />
        <el-table-column prop="create_time" label="注册时间" width="160" />
        <el-table-column prop="last_login" label="最后登录" width="160" />
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button
              v-if="Number(scope.row.is_agent) === 1"
              type="text"
              size="small"
              style="color: #67c23a;"
              @click="toggleAgent(scope.row, 0)"
            >设为普通会员</el-button>
            <el-button
              v-else
              type="text"
              size="small"
              style="color: #e6a23c;"
              @click="toggleAgent(scope.row, 1)"
            >设为代理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 添加会员弹窗 -->
    <el-dialog
      title="添加会员"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form ref="memberForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="手机号" prop="mem_user">
          <el-input v-model="form.mem_user" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="姓名" prop="mem_name">
          <el-input v-model="form.mem_name" placeholder="请输入姓名（可选）" clearable />
        </el-form-item>
        <el-form-item label="昵称" prop="mem_nick">
          <el-input v-model="form.mem_nick" placeholder="请输入昵称（可选）" clearable />
        </el-form-item>
        <el-form-item label="头像" prop="mem_img">
          <el-input v-model="form.mem_img" placeholder="头像URL，不传使用默认头像" clearable />
        </el-form-item>
        <el-form-item label="会员等级" prop="mem_rank">
          <el-input-number v-model="form.mem_rank" :min="1" :step="1" style="width: 180px;" />
        </el-form-item>
        <el-form-item label="邀请码" prop="invite_code">
          <el-input v-model="form.invite_code" placeholder="不传自动生成" clearable />
        </el-form-item>
        <el-form-item label="代理身份" prop="is_agent">
          <el-radio-group v-model="form.is_agent">
            <el-radio :label="0">普通会员</el-radio>
            <el-radio :label="1">代理</el-radio>
          </el-radio-group>
          <div v-if="form.is_agent === 1" style="color: #e6a23c; font-size: 12px; line-height: 1.4;">
            设为代理后将立即停止累计积分
          </div>
        </el-form-item>
        <el-form-item label="登录密码" prop="mem_pass">
          <el-input v-model="form.mem_pass" placeholder="不传默认为空" clearable show-password />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="会员详情" :visible.sync="detailVisible" width="520px">
      <div v-loading="detailLoading">
        <div class="detail-grid" v-if="detail">
          <div class="detail-item">
            <span class="label">头像</span>
            <span class="value">
              <el-avatar :size="44" :src="detail.mem_img || defaultAvatar" />
            </span>
          </div>
          <div class="detail-item"><span class="label">ID</span><span class="value">{{ detail.id }}</span></div>
          <div class="detail-item"><span class="label">手机号</span><span class="value">{{ detail.mem_user || '-' }}</span></div>
          <div class="detail-item"><span class="label">姓名</span><span class="value">{{ detail.mem_name || '-' }}</span></div>
          <div class="detail-item"><span class="label">昵称</span><span class="value">{{ detail.mem_nick || '-' }}</span></div>
          <div class="detail-item"><span class="label">等级</span><span class="value">Lv.{{ detail.mem_rank || 1 }}</span></div>
          <div class="detail-item"><span class="label">邀请码</span><span class="value">{{ detail.invite_code || '-' }}</span></div>
          <div class="detail-item"><span class="label">推广码</span><span class="value">{{ detail.mem_code || '-' }}</span></div>
          <div class="detail-item">
            <span class="label">代理身份</span>
            <span class="value">
              <el-tag size="small" :type="Number(detail.is_agent) === 1 ? 'warning' : 'success'">
                {{ Number(detail.is_agent) === 1 ? '代理' : '普通会员' }}
              </el-tag>
            </span>
          </div>
          <div class="detail-item"><span class="label">会员数</span><span class="value">{{ detail.mem_num || 0 }}</span></div>
          <div class="detail-item"><span class="label">注册时间</span><span class="value">{{ detail.create_time || '-' }}</span></div>
          <div class="detail-item"><span class="label">最后登录</span><span class="value">{{ detail.last_login || '-' }}</span></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { crmLists, crmDetail, crmAdd, crmEdit } from '@/api/crm'

export default {
  name: 'CrmMembers',
  data () {
    return {
      defaultAvatar: 'https://api.gud.91comerp.com/index/upload/05_xdian/default.jpg',
      loading: false,
      memberList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        keyword: '',
        is_agent: ''
      },
      // 添加会员弹窗
      dialogVisible: false,
      submitting: false,
      form: this.getDefaultForm(),
      rules: {
        mem_user: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      // 详情弹窗
      detailVisible: false,
      detailLoading: false,
      detail: null
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    getDefaultForm () {
      return {
        id: null,
        mem_user: '',
        mem_name: '',
        mem_nick: '',
        mem_img: '',
        mem_rank: 1,
        invite_code: '',
        is_agent: 0,
        mem_pass: ''
      }
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.keyword) params.keyword = this.filterForm.keyword
        if (this.filterForm.is_agent !== '' && this.filterForm.is_agent !== null) params.is_agent = this.filterForm.is_agent
        const res = await crmLists(params)
        if (res && String(res.code) === '0') {
          this.memberList = res.data || []
          this.total = res.total || 0
        } else {
          this.memberList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取会员列表失败')
        }
      } catch (error) {
        console.error('获取会员列表失败', error)
        this.memberList = []
        this.total = 0
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { keyword: '', is_agent: '' }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    openAddDialog () {
      this.form = this.getDefaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.memberForm && this.$refs.memberForm.clearValidate()
      })
    },

    closeDialog () {
      this.$refs.memberForm && this.$refs.memberForm.resetFields()
    },

    async submitForm () {
      try {
        await this.$refs.memberForm.validate()
      } catch (e) {
        return
      }

      this.submitting = true
      try {
        const payload = { ...this.form }
        delete payload.id
        // 空字符串字段不传，让后端使用默认值
        Object.keys(payload).forEach(key => {
          if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
            delete payload[key]
          }
        })
        const res = await crmAdd(payload)
        if (res && String(res.code) === '0') {
          this.$message.success(res.msg || '添加成功')
          this.dialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '添加失败')
        }
      } catch (error) {
        console.error('添加会员失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.submitting = false
      }
    },

    async toggleAgent (row, target) {
      const label = target === 1 ? '代理' : '普通会员'
      const tip = target === 1 ? '设为代理后将立即停止累计积分，确定要设置吗？' : '确定将该会员设为普通会员吗？'
      try {
        await this.$confirm(tip, `设为${label}`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        const res = await crmEdit({ id: row.id, is_agent: target })
        if (res && String(res.code) === '0') {
          this.$message.success(`已设为${label}`)
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '操作失败')
        }
      } catch (error) {
        console.error('切换代理身份失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      }
    },

    async openDetail (row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      try {
        const res = await crmDetail({ id: row.id })
        if (res && String(res.code) === '0') {
          this.detail = res.data
        } else {
          this.$message.error(res && res.msg ? res.msg : '获取会员详情失败')
        }
      } catch (error) {
        console.error('获取会员详情失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.crm-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .table-header {
      margin-bottom: 12px;
    }

    .sub-text {
      color: #999;
      font-size: 12px;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}

.detail-grid {
  display: flex;
  flex-wrap: wrap;

  .detail-item {
    width: 50%;
    padding: 6px 0;
    font-size: 13px;

    .label {
      display: inline-block;
      width: 80px;
      color: #999;
    }

    .value {
      color: #303133;
    }
  }
}
</style>
